import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { DropProvider } from './context/DropContext';
import Home from './pages/Home';
import Drop from './pages/Drop';
import Info from './pages/Info';
import Landing from './pages/Landing';
import './App.scss';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		width: "100%",
		height: "100%",
		backgroundColor: theme.custom.colors.baseBgColor
	}
}));

function App() {
	const classes = useStyles();

	return (
		<>
			<div className={`App ${classes.wrapper}`} >
				<DropProvider>
				<BrowserRouter>
					<Switch>
						<Route exact path="/" component={Home} />
						<Route exact path="/drop" component={Drop} />
						<Route exact path="/d/:druid" component={Info} />
						<Route exact path="/landing/:code" component={Landing} />
						<Redirect from='*' to='/landing/404' />
					</Switch>
				</BrowserRouter>
				</DropProvider>
			</div>
		</>
	);
};


export default App;
